import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import styled from 'styled-components';
import * as _ from 'lodash';

//*/

const ElementWrapper = styled.div``;

export default class SelectTagInput extends React.Component {
  static propTypes = {
    width: PropTypes.any,
    dataSource: PropTypes.any,
    onChange: PropTypes.func,
  };

  state = {
    value: null,
  };
  getOptions = () => {
    const data = _.map(this.props.dataSource, (str) => {
      return { value: str, label: str };
    });
    // if (this.state.value) {
    //   const ix = _.findIndex(data, (obj) => {
    //     return obj.value === _.get(this.state.value,'value');
    //   });
    //   if (ix < 0) {
    //     data.push(this.state.value);
    //   }
    // }
   

    return _.compact(data);
  };

  handleOnchange = (obj) => {
    if (this.props.onChange) this.props.onChange(obj);

    // this.setState({
    //   value: obj,
    // });
  };

  // componentDidMount = () => {
  //   this.setState({
  //     value: this.props.value || null,
  //   });
  // };

  render() {
    return (
      <ElementWrapper>
        <Select
          isClearable
          placeholder='-- Select --'
          style={{
            flex: 1,
          }}
          value={this.props.value || null}
          onChange={this.handleOnchange}
          classNamePrefix='react-select-custom'
          options={this.getOptions()}
        />
      </ElementWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/input-tag/select-input-tag.js